import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

import appReducer from './app'
import testReducer from './test'
import resultReducer from './result'

const rootReducer = combineReducers({
  app: appReducer,
  test: testReducer,
  result: resultReducer
})

const middlewares = [thunk]

if (process.env.NODE_ENV !== 'production') {
  const looger = createLogger()
  middlewares.push(looger)
}

export default function configStore() {
  const store = createStore(rootReducer, applyMiddleware(...middlewares))
  return store
}
